import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Updates from "../pages/updates/page";
import Comics from "../pages/comics/page";
import ComicDetail from "../pages/comic/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/updates",
    element: <Updates />,
  },
  {
    path: "/comics",
    element: <Comics />,
  },
  {
    path: "/comic/:id",
    element: <ComicDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;